<template>
    <v-overlay
            :value="visible"
            align="center"
            class="loadin-indicator-container">
        <v-progress-circular
                indeterminate
                size="64"
                class="loading-indicator-spinner" />
        <p
                v-for="(message, key) in messages"
                :key="'message-' + key"
                class="loading-indicator-message">
            {{ message }}
        </p>
    </v-overlay>
</template>

<script>
    export default {
        name: "LoadingIndicator",
        computed: {
            visible() {
                return this.$store.modals.getLoadingVisible();
            },
            messages() {
                return this.$store.modals.getLoadingMessages();
            },
        }
    }
</script>

<style scoped>
    .loading-indicator-message {
        margin-top: 10px;
    }
</style>